import { render } from "./IntroCompany.vue?vue&type=template&id=02bacb7f&scoped=true"
import script from "./IntroCompany.vue?vue&type=script&lang=js"
export * from "./IntroCompany.vue?vue&type=script&lang=js"

import "./IntroCompany.vue?vue&type=style&index=0&id=02bacb7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02bacb7f"]])

export default __exports__